document.querySelectorAll( ".b-faq" ).forEach( ( block ) => {

	const faqItems = block.querySelectorAll( ".js-faq-item" );

	faqItems.forEach( ( item ) => {

		const content = item.querySelector( ".js-faq-content" );

		if ( item.classList.contains( "is-active" ) ) {

			content.style.maxHeight = `${content.scrollHeight}px`;

		}

		item.addEventListener( "click", () => {

			if ( item.classList.contains( "is-active" ) ) {

				content.style.maxHeight = null;

			} else {

				content.style.maxHeight = `${content.scrollHeight}px`;

			}
			item.classList.toggle( "is-active" );

		} );

	} );

} );
